var map = {
	"./emoji-agenda.svg": 681,
	"./emoji-box.svg": 682,
	"./emoji-camera.svg": 683,
	"./emoji-capsule.svg": 684,
	"./emoji-chat.svg": 685,
	"./emoji-done.svg": 686,
	"./emoji-facebook.svg": 687,
	"./emoji-france.svg": 688,
	"./emoji-grec.svg": 689,
	"./emoji-instagram.svg": 690,
	"./emoji-lampe.svg": 691,
	"./emoji-laptop.svg": 692,
	"./emoji-linkedin.svg": 693,
	"./emoji-maroc.svg": 694,
	"./emoji-messagerie.svg": 695,
	"./emoji-money.svg": 696,
	"./emoji-money2.svg": 697,
	"./emoji-pen.svg": 698,
	"./emoji-point.svg": 699,
	"./emoji-smile.svg": 700,
	"./emoji-smileSick.svg": 701,
	"./emoji-stats.svg": 702,
	"./emoji-tick.svg": 703,
	"./emoji-write.svg": 704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;